import useSnackbar from "./useSnackbar";
import { logout } from "../actions/auth";
import { useDispatch } from "react-redux";

export default function useErrorHandler() {
  const snackbar = useSnackbar();
  const dispatch = useDispatch();

  function handleError(err, msg) {
    let e = err?.response?.data?.error;

    if (e) {
      if (err.response.status === 403) {
        dispatch(logout());
        dispatch(snackbar.showError("Session expired please login again."));
      } else {
        dispatch(snackbar.showError(msg || e));
      }
      snackbar.showError(msg || e);
    } else {
      snackbar.showError();
    }
  }

  return handleError;
}
